'use strict';

angular.module('imagetrend.components')
    .directive('hlpDateRange', ['Format', '$timeout', function (Format, $timeout) {
        return {
            restrict: 'AE',
            scope: {
                startDate: '=?',
                endDate: '=?',

                //attributes
                name: '@?',
                id: '@?',
                classes: '@?',
                isDisabled: '=?',

                //required
                isRequired: '=?',
                requiredText: '@?',

                //label
                showLabel: '@?',
                label: '@?',
                title: '@?',
                startLabel: '@?',
                endLabel: '@?',
                useTime: '@?',
                topLabel: '=?',
                showColon: '=?',

                //instructions
                instructions: '@?'
            },
            replace: true,
            templateUrl: 'templates/date-range/date-range.html',
            link: function (scope, elem, attrs, ctrl) {
                //attributes
                if (!attrs.name) { attrs.name = 'date_range'; }
                if (!attrs.id) { attrs.id = attrs.name; }

                //label
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.topLabel) { attrs.topLabel = false; } else { if (attrs.topLabel == true || attrs.topLabel == 'true') { attrs.topLabel = true; } else { attrs.topLabel = false; } }
                if (!attrs.showColon) { attrs.showColon = true; } else { if (attrs.showColon == true || attrs.showColon == 'true') { attrs.showColon = true; } else { attrs.showColon = false; } }
                if (!attrs.title) { attrs.title = attrs.label; }
                if (!attrs.startLabel) { attrs.startLabel = 'Open On'; }
                if (!attrs.endLabel) { attrs.endLabel = 'Close On'; }
                if (!attrs.useTime) { attrs.useTime = true; } else { if (attrs.useTime == 'true') { attrs.useTime = true; } else { attrs.useTime = false; } }

                //required
                //if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }
                $timeout(function () {
                    if (!attrs.requiredText) { scope.requiredText = 'Please enter a ' + Format.label((scope.label || scope.name)) }
                }, 0);

                scope.submitted = false;
                scope.$on('form:submit', function () {
                    scope.submitted = true;
                });

                scope.dateChanged = function () {
                    scope.submitted = false;
                    if (scope.startDate != null) {
                        var startDate = new Date(scope.startDate);
                    }
                    else {
                        var startDate = null;
                    }
                    if (scope.endDate != null) {
                        var endDate = new Date(scope.endDate);
                    }
                    else {
                        var endDate = null;
                    }

                    scope.innerForm.dateRange.$setDirty();

                    if (isValidDate(startDate) && isValidDate(endDate)) {
                        if (new Date(startDate) > new Date(endDate)) {
                            scope.innerForm.dateRange.$setValidity('range', false);
                        }
                        else {
                            scope.innerForm.dateRange.$setValidity('range', true);
                        }
                    }
                    else {                        
                        if (isValidDate(endDate) && !isValidDate(startDate)) {
                            scope.innerForm.dateRange.$setValidity('range', false);
                        }
                        else {
                            scope.innerForm.dateRange.$setValidity('range', true);
                        }
                    }                    
                }

                elem[0].querySelector('input').focus = function () {
                    var firstInvalid = elem[0].querySelector('input.empty');
                    if (firstInvalid) {
                        firstInvalid.focus();
                    }
                    else {
                        var firstInvalid = elem[0].querySelector('input.field');
                        if (firstInvalid) {
                            firstInvalid.focus();
                        }
                    }
                }
            }
        };
    }])
;